import { UploadMetadata } from '@/firebase'
import { createUUID } from '@/helpers/uuid'

type uuid = string
export default class JFileContainer {
  uuid: uuid
  progress = 0
  uploading = false
  file: File
  path: string | undefined = undefined
  metadata: UploadMetadata | undefined = undefined
  url: string | undefined = undefined
  state = 'none'
  error: Error | undefined

  constructor(file: File) {
    // add UUID
    this.uuid = createUUID()
    this.file = file
  }

  get hasProgress() {
    return this.progress > 0
  }
}
